import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const ActionSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default ActionSVG;
